import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ErrorMsg} from '../OrdersPage/OrdersPage.style';

export const Container = styled.div`
  margin-top: 5rem;
  width: 100%;
  color: ${p => p.theme.textColor};

  ${media.medium`
    max-width: 100%;
    overflow: hidden;
  `};
`;

export const PostCodeErrorMsg = styled(ErrorMsg)`
  margin-left: 1rem;
`;

export const LoadingWrapper = styled.div`
  width: 80px;
`;
